import { FormField } from "components/form/FormField/FormField";

import style from "../CervicalCheck.module.css";

export const DoctorDetails = ({ form }) => {
  return (
    <>
      <h2
        style={{
          fontSize: "20px",
          lineHeight: "32px",
          marginTop: "24px",
        }}
      >
        Doctor Details
      </h2>
      <div className={style.inputGroupGrid3}>
        <FormField name="medicalCouncilRegistrationNumber">
          <label className={style.addLetterFormLabel}>
            Medical Council Registration Number
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("medicalCouncilRegistrationNumber")}
            />
          </div>
        </FormField>
        <FormField name="clinicCode">
          <label className={style.addLetterFormLabel}>
            Clinic code (CLIN, COLP, GYN, PPCC, STI or CNC)
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("clinicCode")}
            />
          </div>
        </FormField>
        <FormField name="contractedDoctorName">
          <label className={style.addLetterFormLabel}>
            Contracted Doctor Name
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("contractedDoctorName")}
            />
          </div>
        </FormField>
      </div>
      <div className={style.inputGroupGrid3}>
        <div style={{ gridColumn: "span 2" }}>
          <FormField name="doctorAddress">
            <label className={style.addLetterFormLabel}>Address</label>
            <div>
              <input
                type="text"
                className="form-control"
                {...form.register("doctorAddress")}
              />
            </div>
          </FormField>
        </div>
        <FormField name="doctorContactNumber">
          <label className={style.addLetterFormLabel}>
            Contact Telephone Number
          </label>
          <div>
            <input
              type="text"
              className="form-control"
              {...form.register("doctorContactNumber")}
            />
          </div>
        </FormField>
      </div>
    </>
  );
};
